import fr from './dictionaries/fr.json';
import en from './dictionaries/en.json';
import it from './dictionaries/it.json';

export default { fr, en, it };
